import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import style from "./style";
import React from "react";

const BuildingPanel = ({building}) => (
  <Card>
    <CardHeader style={style.cardHeader} title={building.name} subheader={building.address} />
  </Card>
);

export default BuildingPanel;



// WEBPACK FOOTER //
// ./src/pages/Map/BuildingPanel.jsx